module.exports = __webpack_public_path__ + "img/facebook-logo.2cd285d7.svg";